module.exports = __webpack_public_path__ + "img/aurora-top-angle.bc7388aa.png";